export type Progress = {
  notStudiedCount: number;
  studyingCount: number;
  establishedCount: number;
  perfectCount: number;
  studiedCount?: number;
};

export const sumProgressCount = (progress: Progress) => {
  return Object.values(progress).reduce(
    (prevCount: number, currentCount: number) =>
      prevCount + (currentCount || 0),
    0,
  );
};

export const calcTotalCount = (progress: Progress) => {
  const total = sumProgressCount(progress);
  // NOTE: 0件の場合にバー表示で0除算を防ぐために1を返す
  return total || 1;
};

// DISP-03: allowStudiedAnswer が false の表示単位では「完了(studied)」を集計から除外する。
// 進捗バーの表示セグメントと、その母数(calcTotalCount)を同じ progress から導くために共通化している。
export const applyAllowStudiedAnswer = (
  progress: Progress,
  allowStudiedAnswer: boolean,
): Progress =>
  allowStudiedAnswer ? progress : { ...progress, studiedCount: 0 };

export const toPercent = (numerator: number, denominator: number) => {
  const percent =
    denominator === 0 ? null : Math.round((numerator / denominator) * 100);

  return percent === null ? "ー" : `${percent}%`;
};
